
import { largeDataStorage } from '@/services/storage/largeDataStorage';
import { Student } from '../types';

export const getStudents = async (): Promise<Student[]> => {
  try {
    console.log('📚 Getting students from large data storage...');
    const students = await largeDataStorage.getStudents();
    console.log(`✅ Retrieved ${students.length} students from storage`);
    return students;
  } catch (error) {
    console.error('Error getting students:', error);
    return [];
  }
};

export const addStudent = async (student: Omit<Student, 'id'>): Promise<Student> => {
  try {
    const students = await getStudents();
    const maxId = students.reduce((max, s) => Math.max(max, s.id || 0), 0);
    
    const newStudent: Student = {
      ...student,
      id: maxId + 1,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    const updatedStudents = [...students, newStudent];
    await largeDataStorage.saveStudents(updatedStudents);
    
    console.log(`✅ Added student: ${newStudent.name} (ID: ${newStudent.id})`);
    return newStudent;
  } catch (error) {
    console.error('Error adding student:', error);
    throw error;
  }
};

export const updateStudent = async (id: number, updates: Partial<Student>): Promise<Student | null> => {
  try {
    const students = await getStudents();
    const studentIndex = students.findIndex(s => s.id === id);
    
    if (studentIndex === -1) {
      throw new Error(`Student with ID ${id} not found`);
    }
    
    const updatedStudent: Student = {
      ...students[studentIndex],
      ...updates,
      id,
      updatedAt: new Date().toISOString()
    };
    
    students[studentIndex] = updatedStudent;
    await largeDataStorage.saveStudents(students);
    
    console.log(`✅ Updated student: ${updatedStudent.name} (ID: ${id})`);
    return updatedStudent;
  } catch (error) {
    console.error(`Error updating student ${id}:`, error);
    throw error;
  }
};

export const deleteStudent = async (id: number): Promise<void> => {
  try {
    const students = await getStudents();
    const filteredStudents = students.filter(s => s.id !== id);
    
    if (filteredStudents.length === students.length) {
      throw new Error(`Student with ID ${id} not found`);
    }
    
    await largeDataStorage.saveStudents(filteredStudents);
    console.log(`✅ Deleted student ID: ${id}`);
  } catch (error) {
    console.error(`Error deleting student ${id}:`, error);
    throw error;
  }
};
